import Layout from '../components/MyLayout.js';
import fetch from 'isomorphic-unfetch';
import css from '../sass/sitestyle.scss';
import apiBase from '../utils/apiBase';

const Index = (props) => (
  <Layout {...props}>
    <article className={css['burger-detail']}>
      <div className={css['detail-image-wrap']}>
        <img
          className={css['burger-image-main']}
          src={`/image/${props.burger['img:filename']}`}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = '/image/fallback/burger-fallback.svg';
          }}
          alt={props.burger.burgerName || 'Burger'}
        />
        <span className={css['detail-score']}>{props.burger.burgerScore}</span>
      </div>
      <div className={css['burger-page-details']}>
        <p className={css.eyebrow}>{props.burger.restaurantName}</p>
        <h1 className={css['burger-page-name']}>{props.burger.burgerName}</h1>
        <a className={css['edit-link']} href={`/edit/${props.burger.burgerID}`}>
          Edit review
        </a>
        {props.burger.burgerNotes ? (
          <p className={css['burger-notes']}>{props.burger.burgerNotes}</p>
        ) : null}
        <h2>The scorecard</h2>
        <div className={css['detail-ratings']}>
          <span><small>Flavour</small><strong>{props.burger.meatFlavour}</strong></span>
          <span><small>Texture</small><strong>{props.burger.meatTexture}</strong></span>
          <span><small>Succulence</small><strong>{props.burger.meatSucculence}</strong></span>
          <span><small>Patty ratio</small><strong>{props.burger.meatVolume}</strong></span>
          <span><small>Bun</small><strong>{props.burger.bunRating}</strong></span>
          <span><small>Toppings</small><strong>{props.burger.toppingRating}</strong></span>
          <span><small>Sides</small><strong>{props.burger.sideRating || 0}</strong></span>
          <span><small>Meal</small><strong>{props.burger.mealScore}</strong></span>
        </div>
      </div>
    </article>
  </Layout>
);

const getTopBurgers = async () => {
  let topBurgers = await fetch(`${apiBase}/top/10`);
  topBurgers = await topBurgers.json();
  return topBurgers;
};

const getBurger = async (burgerID) => {
  let burger = await fetch(`${apiBase}/burger/${burgerID}`);
  burger = await burger.json();
  return burger;
};

Index.getInitialProps = async function({ pathname, query }) {
  const topBurgers = await getTopBurgers();
  const burger = await getBurger(query.id);
  return {
    topBurgers,
    burger,
  };
};

export default Index;



// WEBPACK FOOTER //
// pages/burger.js